import { AlertFrequency } from '../../enums';
import { enumToList } from '../enum-to-list';
import { IdName } from '../../models';

export function getAlertFrequency(alertFrequency: AlertFrequency): string {
  switch (alertFrequency) {
    case AlertFrequency.Days:
      return 'Days';
    case AlertFrequency.Weeks:
      return 'Weeks';
    case AlertFrequency.Months:
      return 'Months';
    case AlertFrequency.EndOfProgram:
      return 'End of Program';
  }
}

export function getAlertFrequencyList(): IdName[] {
  return enumToList(AlertFrequency, getAlertFrequency);
}

export function getPeAlertFrequencyList(): IdName[] {
  return enumToList(AlertFrequency, getAlertFrequency).filter((x) => x.id !== AlertFrequency.EndOfProgram);
}
